import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  Typography,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseMenuContent } from "./UseMenuContent";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress, rsParentChilds, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CustomPagination from "../../components/CustomPagination";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import MenuLevel2 from "./MenuLevel2";
import MenuLevel3 from "./MenuLevel3";
import MenuLevel4 from "./MenuLevel4";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { UseFirstPageContent } from "../firstPage/UseFirstPageContent";
import RefreshIcon from "@mui/icons-material/Refresh";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MenuContent() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const { getMenuList, deleteMenu, updateMenu } = UseMenuContent();
  const [filtered, setFiltered] = useState([]);
  const [parentlvl3, setParentlvl3] = useState();
  const [parentlvl4, setParentlvl4] = useState();
  const [PageScrollTo, setPageScrollTo] = useState(
    location.state && location.state.scrollTo
      ? location.state.scrollTo
      : undefined
  );

  const { ResetHeaderFooterCache } = UseFirstPageContent();
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [searchState, setSearchState] = useState(
    parentID && parentID.search1 ? parentID.search1 : ""
  );
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    getMenuList(
      parentID.search1 ? parentID.search1 : "",
      "0",
      (productmenus) => {
        setFiltered(productmenus.menues);
      },
      true
    );
  }, [parentID.search1]);

  const newFunc = () => {
    setParentID({
      search1: "",
      search2: "",
      search3: "",
      search4: "",
      parent2: null,
      parent3: null,
      parent4: null,
      scrolParent2: { top: 0, left: 0 },
      scrolParent3: { top: 0, left: 0 },
      scrolParent4: { top: 0, left: 0 },
    });
    return navigate("/menues/addMenu", {
      state: {
        search: parentID.search1 ? parentID.search1 : "",
        menuRes: filtered,
        ParentID: "0",
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowIndex",
      width: 60,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "نام منو",
      width: 220,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 180,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  return navigate("/menues/editMenu", {
                    state: {
                      model: cellValues.row,
                      id: cellValues.row.id,
                      scrollTo: cellValues.api.getScrollPosition(),
                      search: parentID.search1,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  title: cellValues.row.title,
                  url: cellValues.row.url,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  updateMenu(model, "-", () => {
                    getMenuList(
                      parentID.search1 ? parentID.search1 : "",
                      "0",
                      (productmenus) => {
                        setFiltered(productmenus.menues);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowUpwardIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  title: cellValues.row.title,
                  url: cellValues.row.url,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == filtered.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  updateMenu(model, "-", () => {
                    getMenuList(
                      parentID.search1 ? parentID.search1 : "",
                      "0",
                      (productmenus) => {
                        setFiltered(productmenus.menues);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowDownwardIcon fontSize="small" sx={{}} />
            </IconButton>
            <Tooltip title="Childs">
              <IconButton
                onClick={() => {
                  setParentID({
                    ...parentID,
                    parent2: cellValues.row.id,
                    parent3: null,
                    parent4: null,
                    scrolParent2: cellValues.api.getScrollPosition(),
                    scrolParent3: { top: 0, left: 0 },
                    scrolParent4: { top: 0, left: 0 },
                  });
                }}
              >
                <ArrowLeftIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/menues" }],
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={3}
        sx={{ height: isSmall ? "100% !important" : "60% !important", mb: 10 }}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <TextField
              placeholder="جستجو منو"
              size="small"
              sx={{ mb: 2 }}
              variant="outlined"
              value={searchState ? searchState : ""}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  setParentID({
                    search1: "",
                    search2: "",
                    search3: "",
                    search4: "",
                    parent2: null,
                    parent3: null,
                    parent4: null,
                    scrolParent2: { top: 0, left: 0 },
                    scrolParent3: { top: 0, left: 0 },
                    scrolParent4: { top: 0, left: 0 },
                  });
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setParentID({
                    search1: searchState,
                    search2: "",
                    search3: "",
                    search4: "",
                    parent2: null,
                    parent3: null,
                    parent4: null,
                    scrolParent2: { top: 0, left: 0 },
                    scrolParent3: { top: 0, left: 0 },
                    scrolParent4: { top: 0, left: 0 },
                  });
                }
              }}
            />
            <Button
              color="secondary"
              // sx={{ width: "100px" }}
              variant="contained"
              onClick={(evt) => {
                setProgress(true);
                ResetHeaderFooterCache((csssc) => {
                  setProgress(false);
                });
              }}
            >
              به‌روزرسانی کش
            </Button>
            {/* <IconButton
              onClick={(evt) => {
                setProgress(true);
                ResetHeaderFooterCache((csssc) => {
                  setProgress(false);
                });
              }}
              sx={{
                p: 0.7,
                mr: 1,
                bgcolor: "secondary.main",
                "&:hover": {
  boxShadow: 3,
                      bgcolor: "secondary.main",                },
              }}
            >
              <RefreshIcon fontSize="small" sx={{ fill: "#fff" }} />
            </IconButton> */}
          </Box>
          <DataGrid
            disableVirtualization
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "&  .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
              "&  .MuiDataGrid-cell:focus-within ": {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
              "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
                width: "100% !Important",
              },
              "& .MuiDataGrid-cell:hover": {
                color: "primary.main",
              },
              "& .MuiDataGrid-virtualScrollerRenderZone": {
                width: "100% !important",
              },
              "& .primary": {
                width: "100%",
                backgroundColor: "#ECF6E7 !important",
              },
              "& .none": {
                width: "100%",
                backgroundColor: "#fff !important",
              },
            }}
            columns={columns}
            rows={filtered ? filtered : []}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                scrollTo: PageScrollTo,
                noPage: true,
                newFunc: newFunc,
              },
            }}
            getRowClassName={(params) => {
              if (params.row.id == parentID.parent2) {
                return "primary";
              }
              if (params.row.id !== parentID.parent2) {
                return "none";
              }
            }}
          />
        </Box>
        <Box sx={{ mt: 6 }} gridColumn={isSmall ? "span 12" : "span 6"}>
          <MenuLevel2
            PageScrollTo={PageScrollTo}
            setPageScrollTo={setPageScrollTo}
            setParentlvl3={setParentlvl3}
            parentlvl3={parentlvl3}
          />
        </Box>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={3}
        sx={{
          height: isSmall ? "100% !important" : "60% !important",
          mt: 3,
          mb: 10,
        }}
      >
        <Box sx={{}} gridColumn={isSmall ? "span 12" : "span 6"}>
          <MenuLevel3
            PageScrollTo={PageScrollTo}
            setPageScrollTo={setPageScrollTo}
            setParentlvl4={setParentlvl4}
            parentlvl3={parentlvl3}
            parentlvl4={parentlvl4}
          />
        </Box>
        <Box sx={{ mt: 6 }} gridColumn={isSmall ? "span 12" : "span 6"}>
          <MenuLevel4
            PageScrollTo={PageScrollTo}
            setPageScrollTo={setPageScrollTo}
            parentlvl4={parentlvl4}
          />
        </Box>
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"منو"}
        callback={() => {
          setProgress(true);
          deleteMenu(deleteState.id, () => {
            getMenuList(
              parentID.search1 ? parentID.search1 : "",
              "0",
              (productmenus) => {
                setFiltered(productmenus.menues);
              },
              false
            );
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
